import React, { PureComponent } from 'react';
import classNames from 'classnames';
import TextField from 'pf-onboarding-v2-ui/src/components/text-field';
import ActionArea from './action-area';
import { validNameKey, handleOnPasteForNameField } from '../lib/valid-key';
import Spinner from './spinner';

import Checkbox from './checkbox';

class Agreement extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      consented: false,
      disableAction: false
    };
    this.consent = React.createRef();
  }

  handleFirstNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('signeeFirstName', value, {
      isRequired: true,
      fieldDisplayName: 'Signee First Name'
    });
  }

  handleLastNameChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('signeeLastName', value, {
      isRequired: true,
      fieldDisplayName: 'Signee Last Name'
    });
  }

  handleTitleChange = (e) => {
    const { value } = e.target;
    const { enterFieldData } = this.props.actions;
    enterFieldData('signeeTitle', value, {
      isRequired: true,
      fieldDisplayName: 'Signee Title'
    });
  }

  handleCheckboxSelected = (e) => {
    const consented = !this.state.consented;
    this.setState({ consented });
  }

  handleSubmit = () => {
    const { practice, actions } = this.props;
    const { signAgreement } = actions;
    const { consented } = this.state;
    this.setState({
      disableAction: true
    }, () => {
      signAgreement(practice, consented)
        .then(() => {
          window.location.href = '/patientsolutions/enroll/thank-you';
        })
        .catch(({ response }) => {
          this.setState({ disableAction: false });
          const { data, status } = response;
          if (status && status !== 400) {
            window.location.href = '/patientsolutions/enroll/error';
          }

          if (data && data.redirectTo) {
            window.location.href = data.redirectTo;
          }
        });
      });
  }

  render() {
    const { processingSubmit, enrollmentComplete } = this.props.onboarding;
    const { disableAction, consented } = this.state;
    const checkBoxClasses = classNames({
      'agreement-consent-checkbox--error field-error-msg': this.props.errors.hasConsent && !this.state.consented
    });

    const buttonProps = {
      className: 'button-submit',
      onSubmit: this.handleSubmit,
      buttonActionText: 'Sign Agreement'
    };

    if (disableAction || enrollmentComplete) {
      buttonProps.disabled = true;
    }

    return <section className='header-section agreement-section'>
      <h1 className='section-title'>View and sign your agreement</h1>
      <p>This is the last step in the registration. Once we verify and accept your signed agreement, you’ll be able submit and accept financing applications from patients. Please review the agreement carefully before signing.</p>
      <div className='agreement-main'>
        <form>
          <a 
            data-test-id="review-agreement-button"
            aria-label='review your agreement button'
            className='review-agreement-link'
            href='/patientsolutions/enroll/agreement/view' target='_blank'>
            Review your agreement
          </a>
          <TextField
            data-test-id="signee-first-name-field"
            aria-required
            onBlur={this.handleFirstNameChange}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
            errorMsg={this.props.errors.signeeFirstName}
            defaultValue={this.props.practice.signeeFirstName}
            className='input-helper'
            inputClassName='txt-field-input-medium'
            htmlFor='signee_first_name'
            labelText='Signee First Name'
            labelClassName='section-label'
          />

          <TextField
            data-test-id="signee-last-name-field"
            aria-required
            onBlur={this.handleLastNameChange}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
            errorMsg={this.props.errors.signeeLastName}
            defaultValue={this.props.practice.signeeLastName}
            className='input-helper'
            inputClassName='txt-field-input-medium'
            htmlFor='signee_last_name'
            labelText='Signee Last Name'
            labelClassName='section-label'
          />

          <TextField
            data-test-id="signee-title-field"
            aria-required
            onBlur={this.handleTitleChange}
            onKeyDown={validNameKey}
            onPaste={handleOnPasteForNameField}
            errorMsg={this.props.errors.signeeTitle}
            defaultValue={this.props.practice.signeeTitle}
            className='input-helper'
            inputClassName='txt-field-input-medium'
            htmlFor='signee_title'
            labelText='Signee Title'
            labelClassName='section-label'
          />

          <div className='agreement-consent'>
            <Checkbox
              data-test-id="agreement-checkbox"
              id='checkbox-agreement'
              className={checkBoxClasses}
              checked={consented}
              onClick={this.handleCheckboxSelected}>
              By clicking this box, you agree that you are an owner, officer, partner, or manager of the Provider and have the express authority to agree to this Participating Provider Agreement (“Agreement”) on the Provider’s behalf and to bind the Provider to this Agreement.  You agree that you have read and agree on the Provider’s behalf to the Agreement provided above.
            </Checkbox>
          </div>

          <ActionArea { ...buttonProps } />

          { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }
        </form>
      </div>
    </section>;
  }
}

export default Agreement;

